export { StatusBarModule } from "./statusBarModule.mjs";
